module.exports = __webpack_public_path__ + "img/web-push1-sm.eed20cbb.svg";